import {
  AccessorFn,
  ColumnDef,
  IdentifiedColumnDef,
  createColumnHelper,
} from "@tanstack/react-table"
import _ from "lodash"

import { LibraryResponses } from "@tfg/types/endpoints/library"

export const publicAgecSearchPath = "public-search"

export const ProductsListView = {
  GENERAL: "general",
  TRACEABILITY: "traceability",
  CERTIFICATES: "certificates",
  CUSTOM_FIELDS: "customFields",
} as const

export type ProductsListView =
  (typeof ProductsListView)[keyof typeof ProductsListView]

const traceabilityRanksColumns = (show: boolean) =>
  _.fromPairs(_.times(100, (i) => [`rank-${i}`, show]))

export type AccessorName = Exclude<
  AccessorColumnName<
    ReturnType<typeof createColumnHelper<LibraryResponses.Product>>["accessor"]
  >,
  AccessorFn<LibraryResponses.Product>
>

type AccessorColumnName<Accessor> = Accessor extends (
  accessor: infer T,
  column: IdentifiedColumnDef<LibraryResponses.Product, string>
) => ColumnDef<LibraryResponses.Product, string>
  ? T
  : never

export const PRODUCTS_LIST_VIEWS: {
  [key in ProductsListView]: Record<string /*AccessorName*/, boolean>
} = {
  // TODO: better typing
  // i tried with a Record<AccessorName, boolean> but it's not enough
  general: {
    name: true,
    brand: true,
    purchaseOrder: true,
    reference: true,
    color: true,
    type: true,
    collection: true,
    recycledMaterialPercentage: false,
    releaseMicroplastics: false,
    ...traceabilityRanksColumns(false),
    supplier: true,
    standards: true,
    select: false,
    ingestedAt: true,
    lastPendingIrContact: true,
    recycledMaterial: true,
    traceabilityLaunchedAt: false,
    traceabilityStatus: false,
  },
  traceability: {
    name: true,
    brand: false,
    ingestedAt: false,
    purchaseOrder: true,
    traceabilityStatus: true,
    type: false,
    reference: true,
    color: true,
    manufacturer_name: false,
    collection: true,
    recycledMaterialPercentage: false,
    releaseMicroplastics: false,
    ...traceabilityRanksColumns(true),
    supplier: false,
    standards: false,
    agecShow: false,
    select: false,
    lastPendingIrContact: false,
    recycledMaterial: false,
    traceabilityLaunchedAt: true,
    id: false,
  },
  certificates: {
    name: true,
    brand: true,
    reference: true,
    type: false,
    color: true,
    manufacturer_name: false,
    collection: true,
    recycledMaterialPercentage: false,
    releaseMicroplastics: false,
    ...traceabilityRanksColumns(false),
    supplier: false,
    standards: true,
    select: false,
    lcaLink: false,
    recycledMaterial: false,
    lastPendingIrContact: false,
    traceabilityLaunchedAt: false,
    traceabilityStatus: false,
  },
  customFields: {
    name: true,
    brand: false,
    reference: true,
    color: true,
    type: false,
    manufacturer_name: false,
    collection: true,
    foundCertificateCount: false,
    recycledMaterialPercentage: false,
    releaseMicroplastics: false,
    ...traceabilityRanksColumns(false),
    supplier: false,
    standards: false,
    select: false,
    lcaLink: false,
    recycledMaterial: true,
    lastPendingIrContact: false,
    traceabilityLaunchedAt: false,
    traceabilityStatus: false,
  },
} as const
